import config from "../../../config";
import _ from 'lodash';

export default class EmailManagerApiClient {

    constructor() {
        this.baseUrl = config.emailManager.apiBaseURL + "/api/v1";
    }

    getThreads(accountId, options = {}) {
        let query = null;
        if (options.customerEmail) {
            query = {"customerEmail": options.customerEmail};
        }
        return this.request({
            path: `/accounts/${accountId}/threads`,
            query: query
        }).then(response => {
            let result = EmailManagerApiClient.transformThreadsAPIResponse(response);
            return Promise.resolve(result);
        }).catch(error => {
            console.error('error in EmailManagerApiClient#getThreads():', error);
            return Promise.reject(error);
        });
    }

    getThread(accountId, threadId) {
        return this.request({
            path: `/accounts/${accountId}/threads/${threadId}`
        }).then(response => {
            let result = EmailManagerApiClient.transformThreadAPIResponse(response);
            return Promise.resolve(result);
        }).catch(error => {
            console.error('error in EmailManagerApiClient#getThread():', error);
            return Promise.reject(error);
        });
    }

    replyToMessage(accountId, messageId, from, to, body, files) {
        return this.request({
            method: 'POST',
            path: `/accounts/${accountId}/replyToMessage`,
            files: files,
            body: {
                replyToMessageId: messageId,
                from: from,
                to: to,
                body: body
            }
        }).then(response => {
            return Promise.resolve(response);
        }).catch(error => {
            console.error('error in EmailManagerApiClient#replyToMessage():', error);
            return Promise.reject(error);
        });
    }

    request(options) {
        return new Promise((resolve, reject) => {
            let path = options.path;
            let body = options.body;
            let files = options.files;
            let query = options.query || null;
            let user = options.user || null;
            let password = options.password || null;
            let method = options.method || 'GET';
            let url = this.baseUrl + path + this.queryString(query);
            let xhr = new XMLHttpRequest();

            function handleError() {
                let response = xhr.response;
                if (response && Array.isArray(response['errors']) && response['errors'].length && response['errors'][0].message) {
                    // Email-Manager errors
                    reject(new Error(response['errors'][0].message));
                } else if (xhr.statusText) {
                    reject(new Error(xhr.statusText));
                } else {
                    reject(new Error('Could not fetch response (' + method + ' ' + path + ') due to a network error.'));
                }
            }

            xhr.open(method, url, true);
            xhr.responseType = 'json';
            xhr.onload = function() {
                if (xhr.readyState === 4) {
                    let response = xhr.response;
                    if (xhr.status < 400) {
                        resolve(response.result);
                    } else {
                        handleError();
                    }
                }
            };
            xhr.onerror = handleError;
            xhr.onabort = handleError;
            xhr.withCredentials = true;
            if (files) {
                let formData = new FormData();
                files.forEach(file => {
                    formData.append('files', file);
                });
                formData.append('data', JSON.stringify(body));
                body = formData;
            } else if (body) {
                xhr.setRequestHeader('Content-Type', 'application/json');
                body = JSON.stringify(body);
            }
            if (user) {
                xhr.setRequestHeader('Authorization', 'Basic ' + btoa(user + ':' + (password || '')));
            }
            xhr.send(body);
        });
    }

    queryString(query) {
        if (!query) {
            return '';
        }
        return _.reduce(query, (qs, value, key) => {
            return qs + (qs ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }, '');
    }

    static transformThreadsAPIResponse(threads) {
        return threads.map(thread => {
            return Object.freeze({
                id: thread.id,
                snippet: thread.snippet
            });
        });
    }

    static transformThreadAPIResponse(thread) {
        return Object.freeze({
            id: thread.id,
            //accountId: thread.account_id,
            subject: thread.subject,
            snippet: thread.snippet,
            participants: EmailManagerApiClient.transformContactListAPIResponse(thread.participants),
            //messageIds: thread.message_ids ? thread.message_ids : null,
            messages: Object.freeze(thread.messages.map(EmailManagerApiClient.transformMessageAPIResponse))
        });
    }

    static transformMessageAPIResponse(message) {
        return Object.freeze({
            id: message.id,
            //accountId: message.account_id,
            threadId: message.threadId,
            timestamp: message.timestamp,
            from: EmailManagerApiClient.transformContactListAPIResponse(message.from),
            to: EmailManagerApiClient.transformContactListAPIResponse(message.to),
            cc: EmailManagerApiClient.transformContactListAPIResponse(message.cc),
            subject: message.subject,
            snippet: message.snippet,
            body: message.html ? message.html : null
        });
    }

    static transformContactListAPIResponse(contacts) {
        return Object.freeze(contacts.map(contact => Object.freeze({
            email: contact.email.toLowerCase(),
            name: contact.name
        })));
    }
}



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/EmailManagerApiClient.js